/**
 * Azure AD B2C Configuration
 *
 * This file contains the MSAL configuration for Azure AD B2C authentication.
 * Update the environment variables in .env files with your B2C tenant details.
 */

export const msalConfig = {
  auth: {
    clientId: process.env.VUE_APP_B2C_CLIENT_ID,
    authority: process.env.VUE_APP_B2C_AUTHORITY,
    knownAuthorities: [process.env.VUE_APP_B2C_KNOWN_AUTHORITY],
    redirectUri: process.env.VUE_APP_B2C_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri: process.env.VUE_APP_B2C_POST_LOGOUT_REDIRECT_URI || window.location.origin
  },
  cache: {
    cacheLocation: 'localStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false // Set to true for IE 11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case 0: // LogLevel.Error
            console.error(message)
            break
          case 1: // LogLevel.Warning
            console.warn(message)
            break
          case 2: // LogLevel.Info
            console.info(message)
            break
          case 3: // LogLevel.Verbose
            console.debug(message)
            break
        }
      }
    }
  }
}

const authScopes = [
  process.env.VUE_APP_B2C_SCOPE || 'openid',
  'profile',
  'email',
  'offline_access'
]

export const loginRequest = {
  scopes: authScopes
}

export const tokenRequest = {
  scopes: authScopes,
  forceRefresh: false
}
